import { type Middleware, type Action, BulkOfActions } from '~/state/common/actions'
import { FetchedAccountInfo } from '~/state/currentUser/actions'

import { trackAction, trackActionInternal, trackingConsentHasBeenGranted } from './eventTracking'

export const analyticsMiddleware: Middleware = (store) => {
    const handle = (action: Action) => {
        if (BulkOfActions.match(action)) {
            action.payload.forEach(handle)
            return
        }
        if (FetchedAccountInfo.match(action)) {
            if (action.payload.allowAnalytics) {
                trackingConsentHasBeenGranted()
            }
        }
        trackAction(action, () => store.getState())
        trackActionInternal(action)
    }
    return (next) => (action) => {
        handle(action)
        next(action)
    }
}
